let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5NexJ"), load("kksGF"), load("e1Z8a")]).then(() => parcelRequire('dQOC0'));